import React, { useEffect, useState } from "react";
import ScrollContainer from "react-indiana-drag-scroll";
import API from "../../services/api";
import TableSkelton from "../../shared/TableSkelton";
import NoDataFound from "../../shared/NoDataFound";
import { formatSpentValue, langoptions } from "../../utils/constants";

function AdCodeAlerts() {
  const [logsData, setLogsData] = useState([]);
  const [loader, setLoader] = useState(false);
  const [language, setLanguage] = useState('All')
  const [drop, setDrop] = useState('All')
  useEffect(() => {
    const fetchLogs = async () => {
      setLoader(true);
      try {
        let res = await API({
          url: "/adresponses/getlogs",
          method: "POST",
          responseType: "json",
          data: {
            drop,
            language
          },
        });
        if (res.code === 200) {
          setLogsData(res.data);
        }
      } catch (error) {
        console.error(error);
      } finally {
        setLoader(false);
      }
    };
    fetchLogs();
  }, [language, drop]);

  const handleLanguage = (e)=>{
    setLanguage(e.target.value)
  }

  const handleDrop = (e) =>{
    setDrop(e.target.value)
  }

  const getGreaterOrLesser = (prev, curr) => {
    if(prev > curr){
      return 'text-red-600'
    }else if(prev < curr){
      return ''
    }
  }

  return (
    <>
      <aside className="flex justify-end gap-3">
        <div>
          <label className="form-label">Drop Type</label>
          <select className="form-select" value={drop} onChange={handleDrop}>
            <option value={'All'}>All</option>
            <option value={'Position Wise Drop'}>Position Wise Drop</option>
            <option value={'Overall Drop'}>Overall Drop</option>
            <option value={'Adcode Wise Drop'}>Adcode Wise Drop</option>
          </select>
        </div>
        <div>
          <label className="form-label">Language</label>
          <select className="form-select" value={language} onChange={handleLanguage}>
            <option value='All'>All</option>
            {langoptions.map((lang) => <option value={lang.label} key={lang.value}>{lang.label}</option>)}
          </select>
        </div>
      </aside>
      <ScrollContainer>
        <table className="table table-bordered mt-3">
          <thead>
            <tr className="bg-gray-300">
              <th>Type</th>
              <th>Position</th>
              <th>Langauge</th>
              <th>Adcode</th>
              <th>Message</th>
              <th>Requests</th>
              <th>Responses</th>
              <th>Fill Rate</th>
            </tr>
          </thead>
          {!(loader && logsData.length > 0) ? (
            <tbody>
              {logsData.map((log) => (
                <tr key={log.id}>
                  <td>{log.type}</td>
                  <td>{log.position}</td>
                  <td>{log.language}</td>
                  <td>{log.ad_code}</td>
                  <td>{log.alert_message}</td>
                  <td>
                      <div className="flex flex-row justify-between">
                      <span title={log.total_requests_prev}>
                        {formatSpentValue(log.total_requests_prev)}
                      </span>
                      <span className="border-r"></span>
                      <span title={log.total_requests} className={getGreaterOrLesser(log.total_requests_prev, log.total_requests)}>{formatSpentValue(log.total_requests)}</span>
                    </div>
                  </td>
                  <td>
                    <div className="flex flex-row justify-between">
                      <span title={log.total_responses_prev} >
                        {formatSpentValue(log.total_responses_prev)}
                      </span>
                      <span className="border-r"></span>
                      <span title={log.total_responses} className={getGreaterOrLesser(log.total_responses_prev,log.total_responses)}>{formatSpentValue(log.total_responses)}</span>
                    </div>
                  </td>
                  <td>
                    <div className="flex flex-row justify-between">
                      <span>
                        {parseFloat((log.total_responses_prev / log.total_requests_prev) * 100).toFixed(2) }
                      </span>
                      <span className="border-r"></span>
                      <span className={getGreaterOrLesser(log.total_responses_prev / log.total_requests_prev,log.total_responses / log.total_requests)}>{parseFloat((log.total_responses / log.total_requests) * 100).toFixed(2)}</span>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          ) : loader ? (
            <TableSkelton colspan={7} />
          ) : (
            <NoDataFound colspan={7} />
          )}
        </table>
      </ScrollContainer>
    </>
  );
}

export default AdCodeAlerts;
